var TorsoCollection = require('backbone-torso/modules/Collection');
var formExtService = require('./../urls').formExtService;
var FormModel = require('./FormModel');

/**
 * Receives accounts from the FormExtService
 * @class FormCollection
 * @static
 * @extends Torso.Collection
 */
module.exports = new (TorsoCollection.extend({
  model: FormModel,
  url: formExtService,
  fetchHttpAction: 'POST'
}))();
